import React from 'react';
import { Button, Carousel, Col, Container, Row } from 'react-bootstrap';
import pic1 from '../../../../images/hoteldelux.jpg';
import pic2 from '../../../../images/hoteldelux2.jpg';
import pic3 from '../../../../images/hotel2.jpg';
// import pic4 from '../../../../images/hoteldelux.jpg';

import './ThirdCard.css';

function ThirdCard(props) {

    const update = ()=>{
        props.config("FirstCard");
    }

    return (
        <div>
            <Container style={{paddingBottom:'30px',paddingTop:'10px'}}>
            <Carousel interval={null}  pause='true' fade='true'  >
                <Carousel.Item className='CarouselWrapper' >
                    <img className = "CarouselPhoto"
                    src = {pic2}
                    alt = "First slide" />
                    {/* <Carousel.Caption>
                        <h3>First slide label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item className='CarouselWrapper' >
                    <img className = "CarouselPhoto"
                    src = {pic1}
                    alt = "First slide" />
                    {/* <Carousel.Caption>
                        <h3>Second slide label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item className='CarouselWrapper' >
                    <img className = "CarouselPhoto"
                    src = {pic3}
                    alt = "First slide" />
                    {/* <Carousel.Caption>
                        <h3>Third slide label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
            </Carousel> 
            <Row className='viewMoreRow'>
                    <Col>
                        <Button type='button' onClick={update} className='viewMore'   >View More Rates</Button>
                    </Col>
            </Row>
            
            </Container>
        </div>
    )
}

export default ThirdCard
